import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { ImSpinner9 } from 'react-icons/im';

const colorBase =
  'text-sm py-2 px-4 transition text-center font-semibold rounded-[4px] uppercase tracking-wide';

const colors = {
  regular: cn(
    colorBase,
    'bg-white text-primary border-none hover:bg-blue hover:!text-white',
  ),
  'regular-with-border-gray': cn(
    colorBase,
    'bg-white text-primary border border-gray-200 hover:bg-blue hover:border-blue hover:!text-white',
  ),
  'regular-with-border-primary': cn(
    colorBase,
    'bg-white text-primary border border-primary hover:bg-blue hover:border-blue hover:!text-white',
  ),
  primary: cn(colorBase, 'bg-primary text-white border-none hover:bg-blue'),
  success: cn(
    colorBase,
    'bg-green-500 text-white border-none hover:bg-green-700',
  ),
  danger: cn(colorBase, 'bg-red-500 text-white border-none hover:bg-red-700'),
  default: cn(colorBase, 'bg-primary text-white border-none hover:bg-blue'),
};

const AsyncButton = ({
  spinnerContainerClassName,
  spinnerClassName,
  className,
  isLoading,
  children,
  color,
  ...otherProps
}) => (
  <button
    type="button"
    className={cn(
      colors[color],
      'relative flex items-center uppercase justify-center gap-2',
      isLoading || otherProps.disabled
        ? 'cursor-not-allowed !bg-gray-600 hover:!border-gray-600 hover:!text-gray-400'
        : '',
      className,
    )}
    {...otherProps}
  >
    {isLoading && (
      <div
        className={cn(
          'absolute top-1/2 left-1/2 z-30 transform -translate-x-1/2 -translate-y-1/2 flex items-center gap-2 text-white',
          spinnerContainerClassName,
        )}
      >
        <ImSpinner9
          className={cn('animate-spin text-lg  ', spinnerClassName)}
        />
      </div>
    )}
    <div className={cn(isLoading ? 'opacity-20' : '')}>{children}</div>
  </button>
);

AsyncButton.defaultProps = {
  color: 'default',
  className: '',
  spinnerClassName: '',
  spinnerContainerClassName: '',
  isLoading: false,
};

AsyncButton.propTypes = {
  color: PropTypes.string,
  isLoading: PropTypes.bool,
  className: PropTypes.string,
  spinnerClassName: PropTypes.string,
  spinnerContainerClassName: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default AsyncButton;
